export const features = {
  dev: {
    enableSupportMenu: "dev.show-support-menu",
    /**
     * Whether the Org Context Selector persists the chosen dealership across
     * page loads (sessionStorage) or holds it in memory only.
     *
     * Exists to demo the two behaviours side by side while we decide whether
     * client-side persistence is viable at all: sessionStorage is per-origin,
     * so a selection cannot follow the user between Cox applications.
     *
     * Defaults to **off** — persistence is opt-in. With the flag off (or absent,
     * or not exposed to client-side SDKs) the selection lives in memory only and
     * every page load resolves the first-alphabetical default. Turn it on to
     * demo the sessionStorage behaviour.
     */
    orgContextPersistence: "dev.bridge-bar-org-context-persistence"
  },
  pdt: {
    notificationsLitView: "pdt.bridge-bar.notifications.lit-view",
    /**
     * Whether the side nav is enabled for the user.
     *
     * Unlike the other keys here, this one is NOT evaluated through the
     * client-side LD client. The BFF evaluates it server-side to decide whether
     * to emit any side-nav `user_links` at all, and also forwards it into
     * `feature_flags` so the surface can gate its own render on the same value.
     * One key therefore drives both the data and the rendering, which keeps them
     * from disagreeing — see `SideNavElement`.
     *
     * Because the surface reads the forwarded value, the key must be exposed to
     * client-side SDKs in LaunchDarkly; an unexposed key never reaches the
     * browser and the side nav stays hidden. Defaults to **off** on both sides.
     */
    sideNav: "pdt.show-bridge-bar-side-nav"
  }
};
